import { Controller } from '@hotwired/stimulus'

export default class BaseSimulatorController extends Controller {
  connect() {
    this.refresh(parseFloat(this.inputTarget.value))
  }

  updateDisplay(event) {
    this.refresh(parseFloat(event.target.value))
  }

  preselectInvestAmount() {
    this.dispatch('invest', { prefix: 'simulator', detail: { amount: this.inputTarget.value } })
  }

  refresh(_value) {
    console.warn(`${this.constructor.name} must implement refresh()`)
  }
}
